<div class="grid-container">
  <app-detections-grid></app-detections-grid>
</div>
